import { LMap } from 'vue2-leaflet';
import { TopoLayer } from './layers/TopoLayer';
import { OsmLayer } from './layers/OsmLayer';
import { BikeHikeLayer } from './layers/BikeHikeLayer';
import { BikeHikeHillshadingLayer } from './layers/BikeHikeHillshadingLayer';
import { EsriWorldImage } from './layers/EsriWorldImage';
import { EsriWorldTopo } from './layers/EsriWorldTopo';
import { LMapAdapter } from './LMapAdapter';
import { CyclOSM } from './layers/CyclOSM';

// more layers @ https://leaflet-extras.github.io/leaflet-providers/preview/

export interface ILMapLayer {
    url: string;
    attribution: string;
}

class LMapLayers {
    public topo: ILMapLayer;
    public osm: ILMapLayer;
    public bikeHike: ILMapLayer;
    public bikeHikeHillshading: ILMapLayer;
    public esriWorldImage: ILMapLayer;
    public esriWorldTopo: ILMapLayer;
    public layers: LMapAdapter[];
    public osmCycle: CyclOSM;

    constructor() {
        this.topo = new TopoLayer();
        this.osm = new OsmLayer();
        this.bikeHike = new BikeHikeLayer();
        this.bikeHikeHillshading = new BikeHikeHillshadingLayer();
        this.esriWorldImage = new EsriWorldImage();
        this.esriWorldTopo = new EsriWorldTopo();
        this.osmCycle = new CyclOSM();
        this.layers = Array<LMapAdapter>();
        this.layers.push(new LMapAdapter('Topographic', this.topo));
        this.layers.push(new LMapAdapter('Open street map', this.osm));
        this.layers.push(new LMapAdapter('Bike hike', this.bikeHike));
        this.layers.push(new LMapAdapter('Bike hike hills', this.bikeHikeHillshading));
        this.layers.push(new LMapAdapter('Esri image', this.esriWorldImage));
        this.layers.push(new LMapAdapter('Esri topo', this.esriWorldTopo));
        this.layers.push(new LMapAdapter('OSM cycle', this.osmCycle));
    }

    public getTileLayers() {
        const layerObject = {};
        this.layers.forEach((l) => layerObject[l.title] = l.getTileLayer());
        return layerObject;
    }
}

const lml = new LMapLayers();

export { lml };
